/*
  +--------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     账户管理-用户 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getUserInfoApi() {
  return request({
    url: '?c=fam&a=user&do=get',
    method: 'get'
  })
}

export function postUserInfoApi(formData) {
  return request({
    url: '?c=fam&a=user&do=post',
    method: 'post',
    data: formData
  })
}
